import { FC } from 'react';
import { IconButton } from '@material-ui/core';

interface ToolbarButtonProps {
  label: React.ReactNode;
  active: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const ToolbarButton: FC<ToolbarButtonProps> = ({ label, active, disabled, onClick }) => {
  return (
    <IconButton
      type="button"
      size="small"
      disabled={disabled}
      aria-pressed={active}
      color={active ? 'primary' : 'default'}
      onMouseDown={event => event.preventDefault()}
      onClick={onClick}
      style={{ padding: 8, borderRadius: 8, background: active ? '#0f16240d' : '' }}
    >
      {label}
    </IconButton>
  );
};

export default ToolbarButton;
